import { MarkSpec } from 'prosemirror-model'

export const strikethrough: MarkSpec = {
  parseDOM: [
    { tag: 'strike' },
    { style: 'text-decoration=line-through' },
    { style: 'text-decoration-line=line-through' },
    { tag: 's' },
  ],
  toDOM: () => ['s', 0],
}
